import {
  ConfigQuery,
  CountriesEnum,
  CountryData,
  CountryObject,
  LocalesEnum,
} from '../generated/operations';
import { isEnum } from './isEnum';
import { DEFAULT_COUNTRY } from '../components/constants';
import { UserSettings } from '../types/UserSettings';
import { parseUrl } from './parseUrl';
import { defaultUserSettings } from 'src/global/defaultUserSettings';



export function parseSettingsFromUrl(
  config: ConfigQuery,
  global: Window = window,
): UserSettings {

  const {location} = global;
  const url = parseUrl(location.toString());

  if (!url) {
    return defaultUserSettings;
  }

  const country = url.searchParams.get('country');
  const language = url.searchParams.get('language');

  if (country === null || language === null) {
    return defaultUserSettings;
  }
  const countryCodeFromUrl = getCountryCodeOrDefault(country);
  const {code: countryCode, data: countryData} = getCountryData(countryCodeFromUrl, config);

  if (!countryData) {
    return defaultUserSettings;
  }

  return {
    shoppingCenter: countryData.shoppingCenter || null,
    currentCountry: countryCode,
    currentRegion: countryData.region,
    currentLocale: getLocale(countryData, language),
  }

}

export function getCountryData(country: string, {countries}: ConfigQuery) {
  return countries.find((item) => item.code === country) as CountryObject;
}

export function getLocale(countryData: CountryData, language: string): LocalesEnum {
  const localeData = countryData.locales
    .find(({locale}) => locale.substring(0, 2) === language.substring(0, 2));
  if (localeData) {
    return localeData.locale;
  }
  const [{locale}] = countryData.locales;
  return locale;
}

export function getCountryCodeOrDefault(input: string): CountriesEnum {
  if (!!input && isEnum(input, CountriesEnum)) {
    return input as CountriesEnum;
  }
  return DEFAULT_COUNTRY;
}
